import React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { NodeArticle } from '../../../../types/uncinc_profile/nodes';
import { SCREEN_WIDE } from '../../../../config/constants';
import TeaserSmall from '../../../../components/Teaser/Small';
import TeaserBig from '../../../../components/Teaser/Big';

interface NodeArticleTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeArticle>;
  highlighted?: boolean;
  large?: boolean;
}

const NodeArticleTeaser: React.FC<NodeArticleTeaserProps> = ({ entity, highlighted, large }) => {
  const { t } = useTranslation();
  const article = entity.toJS();
  const { width } = useWindowDimensions();
  const type = article.field_article_type?.[0]?.entity?.name[0].value ?? t('content_types.article.type');

  if (highlighted) {
    return (
      <TeaserBig
        node={article}
        typeLabel={type}
        highlighted
        large={large}
      />
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {width < SCREEN_WIDE && !large ? (
        <TeaserSmall
          node={article}
          typeLabel={type}
        />
      ) : (
        <TeaserBig
          node={article}
          typeLabel={type}
          large={large}
        />
      )}
    </>
  );
};

export default NodeArticleTeaser;
